import { render, staticRenderFns } from "./Luogo.vue?vue&type=template&id=658153f5&"
import script from "./Luogo.vue?vue&type=script&lang=js&"
export * from "./Luogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports